import SignatureForm from "./components/SignatureForm";
import "./App.css";
import { Header } from "./components/Header";

function App() {
  console.log("App component rendered");
  return (
    <div className="App">
      <Header />
      <main>
        <SignatureForm />
      </main>
    </div>
  );
}

export default App;
